import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function AddSalary({availableWorkers}) {                
  
const [newSalary, setNewSalary]=useState([]);
const api_url = process.env.REACT_APP_API_URL;
const complex_name = localStorage.getItem('complex_name');
const [saveStatus, setSaveStatus] = useState("");
const [saveButtonDisable, setSaveButtonDisable] = useState(false);             

function handleChange(e) {
    setNewSalary({
      ...newSalary,
      [e.target.name]: e.target.value
    });
}

async function createSalary() {
    
    setSaveButtonDisable(true);                               //сразу выключаю кнопку сохранения, чтобы не нажимали дважды

    let worker_info = availableWorkers.find((s) => s.workerId === newSalary.workerId)
    let full_name = worker_info.fullName;

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        body: JSON.stringify({worker_id: newSalary.workerId, full_name: full_name, salary_amount: newSalary.salaryAmount, complex_name: complex_name, comment: newSalary.comment})
    };

    const saving_visit = await fetch(api_url+"/api/addSalary", requestOptions);

    const body = await saving_visit.json();
    if (body.message === "Salary added successfully!") {
      setSaveStatus("success");
    }
    else {
      setSaveStatus("error");
      setSaveButtonDisable(false);
    }
}

return (
    <div className='edit-worker-modal'>
    <h1 className="modal-header"> Добавить выплату ЗП </h1>
      <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="demo-simple-select-label">Сотрудник:</InputLabel>
        <Select
          value={newSalary.worker_id}
          label="Сотрудник:"
          name="workerId"
          fullWidth
          onChange={handleChange}
        >
        {availableWorkers.map(({workerId, fullName}) => (                           //листим каталог работ
        <MenuItem key={workerId} value={workerId}> {fullName} </MenuItem>
        ))}
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Сумма</InputLabel>
        <OutlinedInput
          name="salaryAmount"
          value={newSalary.salaryAmount}
          onChange={handleChange}
          label="Сумма"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Комментарий</InputLabel>
        <OutlinedInput
          id="comment"
          name="comment"
          value={newSalary.comment}
          onChange={handleChange}
          label="Комментарий"
        />
        </FormControl>
        
        <Button variant="contained"
            sx={{mb:1.5, mt:1.5}} fullWidth
            disabled={saveButtonDisable}
            color="success"
            className="mr10"
            onClick={() => createSalary()}>Добавить выплату ЗП</Button>
        {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введенных данных!</Alert>}
        {saveStatus === "success" && <Alert severity="success">Изменения успешно сохранены!</Alert>}
        </Box>
    </div>
)}